import { React, Table } from '@1337lawyers/design';

export const CompletedVerificationRequests = () => (
  <Table headers={['Task', 'Requested', 'Status']} data={[]} />
);
